/// <reference path="app.hilo.controllers.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="../../common/controllers/screencontrollerbase.ts" />
module App.HiLO.Controllers {
 
    'use strict';

    class HomeController extends App.Common.Controllers.ScreenControllerBase {
        public static $inject = ['$injector'];
        public busyPromise: angular.IPromise<any>;
        constructor($injector: angular.auto.IInjectorService) {
            super($injector);
            this.title = 'Request a consent or discharge for your property - Homes England';
            this.titleSecondary = 'Request a consent or discharge for your property';
          
        }
        public beforeInitialize(): angular.IPromise<any> {
            return this.setAuthenticationRequired(false);
        }

        public initialize(): angular.IPromise<any> {
            return this.$q.resolve() ; 
        }

    }


    angular
        .module('app.hilo.controllers')
        .controller('app.hilo.controllers.homeController', HomeController);

}